import {Injectable} from '@angular/core';
import {SearchHelper} from "./search-helper";
import {AdnHttpService} from '../../../util/adn-http.service';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';
import {LocalUserProfile} from '../../../session/local-user-profile';



@Injectable()
export class RecentArticlesSearchResource extends SearchHelper {
  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService,
    localUserProfile: LocalUserProfile
  ) {
    super(AdnHttp, authHttpInterceptor, ApiErrorHandler, localUserProfile, 'targetingquery/recentarticles');
  }

  query(a1): any {
    this.updateEndPoint('targetingquery/recentarticles');
    return super.query(a1);
  }

  viewed(a1): any {
    this.updateEndPoint('targetingquery/viewedarticles');
    return super.query(a1);
  }
}
